import { ORPCError } from '@orpc/client';
import { QueryClient } from '@tanstack/vue-query';

/** One cache for the app. Refusals are answers, not glitches: only other failures are retried. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failures, error) => !(error instanceof ORPCError && error.status < 500) && failures < 2,
    },
  },
});
